import React from 'react';
import { Container, Typography, Grid, Card, CardContent, Button, Box } from '@mui/material';

const documents = [
  {
    id: 1,
    title: 'ISO 9001:2015 Quality Certificate',
    description: 'ISO 9001:2015 certification confirming adherence to international quality management standards.',
    file: '/assets/documents/无锡东和欣iso证书.pdf',
  },
  {
    id: 2,
    title: 'RoHS Compliance Test Report',
    description: 'RoHS compliance report detailing material safety standards.',
    file: '/assets/documents/BIAN- ROHS测试（英文）-副本.pdf',
  },
  {
    id: 3,
    title: 'Steel Manufacturer Brochure',
    description: "Bilingual (Chinese/English) overview of the manufacturer's product range, operations, and capabilities.",
    file: '/assets/documents/东和欣宣传中英文版-V2-20240516(2).pdf',
  },
  {
    id: 4,
    title: 'Laminated Steel Sheets',
    description: 'Detailed product information and application for laminated steel sheets.',
    file: '/assets/documents/240424金属复膜包装宣传册.pdf',
  },
  {
    id: 5,
    title: 'Coated Steel Sheets',
    description: 'Detailed product information and applications for coated steel sheets.',
    file: '/assets/documents/coatedSteelSheet.pdf',
  },
  {
    id: 6,
    title: 'Black Plate Tinplate Sheets',
    description: 'Detailed product information and applications for black plate tinplate sheets',
    file: '/assets/documents/DHX TINPLATE CATALOGUE -240424.pdf',
  },
];

const Trading: React.FC = () => {
  return (
    <Container
      style={{
        marginTop: '50px',
        padding: '20px',
        fontFamily: 'Roboto, sans-serif',
      }}
      maxWidth="lg"
    >
      {/* Hero Section */}
      <Box
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '40px',
          marginBottom: '60px',
          flexWrap: 'wrap',
        }}
      >
        {/* Left: text */}
        <Box style={{ flex: '1 1 300px', minWidth: '280px' }}>
          <Typography variant="h4" style={{ fontWeight: 'bold', marginBottom: '16px' }}>
            Trading Resources
          </Typography>
          <Typography variant="body1" style={{ color: '#555', lineHeight: 1.8 }}>
            Download the latest certifications, reports, and brochures related to our trading
            operations. We work with leading manufacturers to bring you high-quality steel and
            industrial materials backed by rigorous compliance documentation.
          </Typography>
        </Box>
      </Box>

      {/* Documents Grid */}
      <Typography variant="h5" style={{ fontWeight: 'bold', marginBottom: '24px', textAlign: 'center' }}>
        Document Downloads
      </Typography>
      <Grid container spacing={4}>
        {documents.map((doc) => (
          <Grid item xs={12} sm={6} md={4} key={doc.id}>
            <Card style={{ height: '100%' }}>
              <CardContent>
                <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                  {doc.title}
                </Typography>
                <Typography variant="body2" style={{ marginBottom: '20px', color: '#777' }}>
                  {doc.description}
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ textTransform: 'none' }}
                >
                  Download
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Trading;
